"use strict";
var IFloodgateStorageProvider;
(function (IFloodgateStorageProvider) {
    /**
     * Enum for the files used by floodgate
     */
    var FileType;
    (function (FileType) {
        FileType[FileType["FloodgateSettings"] = 0] = "FloodgateSettings";
        FileType[FileType["SurveyActivationStats"] = 1] = "SurveyActivationStats";
        FileType[FileType["SurveyEventActivityStats"] = 2] = "SurveyEventActivityStats";
        FileType[FileType["CampaignDefinitions"] = 3] = "CampaignDefinitions";
        FileType[FileType["CampaignStates"] = 4] = "CampaignStates";
        FileType[FileType["GovernedChannelStates"] = 5] = "GovernedChannelStates";
    })(FileType = IFloodgateStorageProvider.FileType || (IFloodgateStorageProvider.FileType = {}));
})(IFloodgateStorageProvider || (IFloodgateStorageProvider = {}));
module.exports = IFloodgateStorageProvider;
